import styled from 'styled-components';

export const BulkActionsBar = styled.div<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  /* Zielony gradient spójny z sidebar (Sidebar.styled.ts). */
  background: linear-gradient(135deg, #047857 0%, #064e3b 100%);
  color: white;
  gap: 12px;
  /* Spójne zaokrąglenie z FilterBar i ListTableWrap (12px). */
  border-radius: 12px;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const BulkActionsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BulkActionsCount = styled.span`
  font-size: 14px;
  font-weight: 300;
  color: white;
`;

export const BulkActionsRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;

    button {
      flex: 1;
    }
  }
`;

export const BulkActionButton = styled.button<{ $variant?: 'danger' | 'primary' }>`
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
  white-space: nowrap;

  ${({ $variant }) => {
    switch ($variant) {
      case 'danger':
        return `
          background: #ef4444;
          color: white;

          &:hover:not(:disabled) {
            background: #dc2626;
          }
        `;
      case 'primary':
        return `
          background: rgba(255, 255, 255, 0.2);
          color: white;

          &:hover:not(:disabled) {
            background: rgba(255, 255, 255, 0.3);
          }
        `;
      default:
        return `
          background: rgba(255, 255, 255, 0.15);
          color: white;

          &:hover:not(:disabled) {
            background: rgba(255, 255, 255, 0.25);
          }
        `;
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }
`;
